import React, { useEffect, useState } from "react";
import { Grid, Box, Checkbox } from "@mui/material";
import "./GovtTaxEditModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import Loader from "../../../Lottifiers/Loader/Loader";
import GovtTaxCheckBox from "../../../components/GovtTaxCheckBox/GovtTaxCheckBox";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackData: (data: any) => void;
  govtTaxes: any;
  assignedTaxesToEmployees: any;
  currency: any;
  isLoading?: boolean;
}

const GovtTaxEditModalPresenter = ({
  isModalOpen,
  closeModal,
  govtTaxes,
  callBackData,
  assignedTaxesToEmployees,
  currency,
  isLoading,
}: ModalProps) => {
  const [selectedTaxIds, setSelectedTaxIDs] = useState([]);

  const getAssignedTaxIds = (taxIds: any) => {
    setSelectedTaxIDs(taxIds);
  };

  const handleSubmit = () => {
    callBackData({
      taxIds: selectedTaxIds,
    });
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      {isLoading ? (
        <Loader height={100} width={200} />
      ) : (
        <>
          <ModalHeader
            modal={{ modal_title: "Edit Goverement Tax" }}
            closeModal={closeModal}
          />
          <Box style={{ marginTop: "35px" }} />
          <GovtTaxCheckBox
            assignedTaxesToEmployees={assignedTaxesToEmployees}
            getNewAssignedTaxes={getAssignedTaxIds}
            data={govtTaxes}
            currency={currency}
          />

          <Box style={{ marginTop: "35px" }} />
          <ModalFooter
            onClickSubmit={() => handleSubmit()}
            onClickCancel={() => {
              closeModal();
            }}
          />
        </>
      )}
    </CustomModal>
  );
};

export default GovtTaxEditModalPresenter;
